<template>
  <div class="dept_container">
    <div class="department_title">
      房源规格查询
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="输入搜索：">
        <el-input
          v-model="formInline.vMenuName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="状态：" class="left_margin">
        <el-select v-model="formInline.status" placeholder="部门状态" clearable>
          <el-option label="正常" value="0"></el-option>
          <el-option label="停用" value="1"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item class="left_margin">
        <el-button type="primary" @click="onSubmit" class="inquire"
          >搜索</el-button
        >
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="newly_built" v-if="activeName == 'first'">
      <el-button
        type="primary"
        icon="el-icon-plus"
        class="newly_built_btn"
        @click="menuAdd"
        v-if="premission('New:Specification')"
        >新建</el-button
      >
    </div>
    <div class="newly_built" v-if="activeName == 'second'">
      <el-button
        type="primary"
        icon="el-icon-plus"
        class="newly_built_btn"
        @click="menuAdd_specification"
        v-if="premission('New:Specification')"
        >新建</el-button
      >
    </div>
    <el-tabs v-model="activeName" @tab-click="TabsHandleClick">
      <el-tab-pane label="配套设施管理" name="first">
        <!-- 配套设施管理 -->
        <el-table
          :data="tableData"
          row-key="iConfigId"
          style="width: 100%"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          >
          <el-table-column prop="vMenuName" label="设施服务" width="180">
          </el-table-column>
          <el-table-column prop="iOrderNumber" label="本级排序" width="180">
          </el-table-column>

          <el-table-column prop="path" label="图标" width="180">
          </el-table-column>
          <el-table-column prop="vUpdatePeople" label="修改人" width="180">
          </el-table-column>
          <el-table-column prop="vUpdateDate" label="修改日期" width="180">
          </el-table-column>
          <el-table-column label="空值显示" width="180">
            <template slot-scope="scope">
              {{ scope.row.iNullDisplay == 1 ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="是否显示" width="180">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.iConfigStatus"
                active-color="#F6B439"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
                @change="switch_value_btn(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="operation_right"
                icon="el-icon-plus"
                @click="menuAdd(scope.row)"
                v-if="premission('Add:Subordinate')"
                >添加菜单</el-button
              >
              <el-button
                type="text"
                class="operation_right"
                icon="el-icon-edit-outline"
                @click="redact(scope.row)"
                v-if="premission('Edit:Specification')"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="Delete(scope.row)"
                v-if="premission('Delete:Specification')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table></el-tab-pane
      >
      <!-- 房源规格管理 -->
      <el-tab-pane label="房源规格管理" name="second">
        <el-table
          :data="tableDataOther"
          style="width: 100%"
          row-key="iConfigId"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column prop="vMenuName" label="分类名称" width="180">
          </el-table-column>
          <el-table-column prop="iOrderNumber" label="本级排序" width="180">
          </el-table-column>
          <el-table-column prop="vUpdatePeople" label="修改人" width="180">
          </el-table-column>
          <el-table-column prop="vUpdateDate" label="修改日期" width="180">
          </el-table-column>
          <el-table-column label="是否显示" width="180">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.iConfigStatus"
                active-color="#F6B439"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
                @change="switch_value_btn(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="operation_right"
                icon="el-icon-plus"
                @click="menuAdd_specification(scope.row)"
                v-if="premission('Add:Subordinate')"
                >添加菜单</el-button
              >
              <el-button
                type="text"
                class="operation_right"
                icon="el-icon-edit-outline"
                @click="redact(scope.row)"
                v-if="premission('Edit:Specification')"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="Delete(scope.row)"
                v-if="premission('Delete:Specification')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 配套设施管理新增菜单弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="sizeForm"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="上级分类:" prop="vFatherId">
          <treeselect
            v-model="sizeForm.vFatherId"
            :options="menuOptions"
            :normalizer="normalizer"
            :show-count="true"
            placeholder="选择上级菜单"
          />
        </el-form-item>

        <el-form-item label="设施名称:" prop="vMenuName">
          <el-input
            v-model="sizeForm.vMenuName"
            placeholder="请输入菜单名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="上传图标:">
          <el-upload
            :limit="1"
            :headers="headers"
            name="avatarfile"
            :action="GLOBAL"
            list-type="picture-card"
            :on-success="handleAvatarSuccessFour"
            :on-remove="handleRemove"
          >
            <i class="el-icon-upload"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible_img">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="本级排序:" prop="iOrderNumber">
          <el-input
            v-model="sizeForm.iOrderNumber"
            placeholder="填写排序"
          ></el-input>
        </el-form-item>
        <el-form-item label="显示空值:">
          <el-radio v-model="sizeForm.iNullDisplay" label="1">是</el-radio>
          <el-radio v-model="sizeForm.iNullDisplay" label="0">否</el-radio>
        </el-form-item>

        <el-form-item label="显示状态:">
          <el-radio v-model="sizeForm.iConfigStatus" label="1">显示</el-radio>
          <el-radio v-model="sizeForm.iConfigStatus" label="0">不显示</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="add_new_btn" class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 房源规格管理新增弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible_specification"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="sizeFormOther"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="上级分类:" prop="vFatherId">
          <treeselect
            v-model="sizeFormOther.vFatherId"
            :options="menuOptions"
            :normalizer="normalizer"
            :show-count="true"
            placeholder="选择上级菜单"
          />
        </el-form-item>

        <el-form-item label="分类名称:" prop="vMenuName">
          <el-input
            v-model="sizeFormOther.vMenuName"
            placeholder="请输入菜单名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="本级排序:" prop="iOrderNumber">
          <el-input
            v-model="sizeFormOther.iOrderNumber"
            placeholder="填写排序"
          ></el-input>
        </el-form-item>
        <el-form-item label="显示状态:">
          <el-radio v-model="sizeFormOther.iConfigStatus" label="1"
            >显示</el-radio
          >
          <el-radio v-model="sizeFormOther.iConfigStatus" label="0"
            >不显示</el-radio
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="add_new_btn" class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import premission from "../../utils/permission";
import {
  configListAjax,
  insertConfigAjax,
  insertConfigQueryAjax,
  updateConfigAjax,
  configListDelete,
  insertConfigchange
} from "../../api/index";
import { handleTreeOther } from "../../utils/treating";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import premission from "../../utils/permission";
export default {
  components: { Treeselect },
  mixins: [premission],
  data() {
    return {
      throttle: true,
      dialogImageUrl: "",
      dialogVisible_img: false,
      activeName: "first",
      // 弹出层标题
      title: "",
      // 修改菜单弹窗
      dialogVisibleRedact: false,
      // 新建公司弹窗
      dialogVisible: false,
      dialogVisible_specification: false,
      // //是否显示
      // switch_value: "1",
      // 搜索数据
      formInline: {
        vMenuName: ""
      },
      // 新建配套设施管理数据
      sizeForm: {
        vFatherId: "",
        vMenuName: undefined,
        iOrderNumber: "",
        iNullDisplay: "0",
        iConfigStatus: "0",
        iMenuBelong: 1
      },
      //  新建房源管理数据
      sizeFormOther: {
        vFatherId: "",
        vMenuName: undefined,
        iOrderNumber: "",
        iConfigStatus: "0",
        iMenuBelong: 2
      },
      // 表单数据
      tableData: [],
      tableDataOther: [],
      // 菜单树选项
      menuOptions: [],
      // 表单校验
      rules: {
        vFatherId: [
          { required: true, message: "上级菜单不能为空", trigger: "blur" }
        ],
        vMenuName: [
          { required: true, message: "菜单名称不能为空", trigger: "blur" }
        ],
        iOrderNumber: [
          { required: true, message: "显示排序不能为空", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer " + this.$store.state.user // 直接从本地获取token就行
      };
    }
  },
  created() {
    this.getHourselistAjax();
  },
  methods: {
    //搜索
    async onSubmit() {
      if (!this.throttle) return;
      this.throttle = false;
      const { data: res } = await configListAjax(this.formInline);
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.throttle = true;
      this.tableData = handleTreeOther(res.data.configList, "iConfigId");
      this.tableDataOther = handleTreeOther(
        res.data.houseConfigList,
        "iConfigId"
      );
    },
    // 重置
    reset() {
      this.formInline.vMenuName = "";
      this.getHourselistAjax();
    },
    // 获取表单数据
    async getHourselistAjax() {
      if (!this.throttle) return;
      this.throttle = false;
      const { data: res } = await configListAjax();
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.throttle = true;
      this.tableData = handleTreeOther(res.data.configList, "iConfigId");
      this.tableDataOther = handleTreeOther(
        res.data.houseConfigList,
        "iConfigId"
      );
    },
    // 新增按钮
    menuAdd(row) {
      this.dialogVisible = true;
      this.getTreeselect();
      this.sizeForm.iMenuBelong = 1;
      if (row != null && row.iConfigId) {
        this.sizeForm.vFatherId = row.iConfigId;
      } else {
        this.sizeForm.vFatherId = 0;
      }
      this.title = "新建";
    },
    menuAdd_specification(row) {
      console.log(1);
      this.getTreeselect();
      this.sizeFormOther.iMenuBelong = 2;
      if (row != null && row.iConfigId) {
        this.sizeFormOther.vFatherId = row.iConfigId;
      } else {
        this.sizeFormOther.vFatherId = 0;
      }
      this.title = "新建";
      this.dialogVisible_specification = true;
    },
    // 编辑按钮
    async redact(e) {
      if (this.activeName == "first") {
        this.getTreeselect();
        const { data: res } = await insertConfigQueryAjax(e.iConfigId);
        this.sizeForm = res.data;
        // this.sizeForm.vFatherId = res.data.vFatherId;
        // this.sizeForm.vMenuName = res.data.vMenuName;
        // this.sizeForm.iOrderNumber = res.data.iOrderNumber;
        // this.sizeForm.iNullDisplay = res.data.iNullDisplay.toString();
        // this.sizeForm.iConfigStatus = res.data.iConfigStatus.toString();
        this.title = "编辑";
        this.dialogVisible = true;
      }
      if (this.activeName == "second") {
        this.getTreeselect();
        const { data: res } = await insertConfigQueryAjax(e.iConfigId);
        this.sizeFormOther = res.data;
        // this.sizeFormOther.vFatherId = res.data.vFatherId;
        // this.sizeFormOther.vMenuName = res.data.vMenuName;
        // this.sizeFormOther.iOrderNumber = res.data.iOrderNumber;
        // this.sizeFormOther.iConfigStatus = res.data.iConfigStatus.toString();

        this.title = "编辑";
        this.dialogVisible_specification = true;
      }
    },

    // 新建公司弹窗确认和取消
    async add_new_btn() {
      if (this.activeName == "first") {
        if (this.title == "新建") {
          this.$refs.form.validate(async valid => {
            if (valid) {
              const { data: res } = await insertConfigAjax(this.sizeForm);
              if (res.code !== 200)
                return this.$message({
                  type: "error",
                  message: res.msg
                });
              this.$message({
                type: "success",
                message: res.msg
              });
              this.sizeForm = {
                vFatherId: "",
                vMenuName: undefined,
                iOrderNumber: "",
                iNullDisplay: "0",
                iConfigStatus: "0",
                iMenuBelong: 1
              };
              this.getHourselistAjax();
              this.dialogVisible = false;
            } else {
              return false;
            }
          });
        } else {
          this.$refs.form.validate(async valid => {
            if (valid) {
              const { data: res } = await updateConfigAjax(this.sizeForm);
              if (res.code !== 200)
                return this.$message({
                  type: "error",
                  message: res.msg
                });
              this.$message({
                type: "success",
                message: res.msg
              });
              this.sizeForm = {
                vFatherId: "",
                vMenuName: undefined,
                iOrderNumber: "",
                iNullDisplay: "0",
                iConfigStatus: "0",
                iMenuBelong: 1
              };
              this.getHourselistAjax();
              this.dialogVisible = false;
            } else {
              return false;
            }
          });
        }
      }

      if (this.activeName == "second") {
        if (this.title == "新建") {
          this.$refs.form.validate(async valid => {
            if (valid) {
              const { data: res } = await insertConfigAjax(this.sizeFormOther);
              if (res.code !== 200)
                return this.$message({
                  type: "error",
                  message: res.msg
                });
              this.$message({
                type: "success",
                message: res.msg
              });
              this.sizeFormOther = {
                vFatherId: "",
                vMenuName: undefined,
                iOrderNumber: "",
                iConfigStatus: "0",
                iMenuBelong: 2
              };
              this.getHourselistAjax();
              this.dialogVisible_specification = false;
            } else {
              return false;
            }
          });
        } else {
          this.$refs.form.validate(async valid => {
            if (valid) {
              const { data: res } = await updateConfigAjax(this.sizeFormOther);
              if (res.code !== 200)
                return this.$message({
                  type: "error",
                  message: res.msg
                });
              this.$message({
                type: "success",
                message: res.msg
              });
              this.sizeFormOther = {
                vFatherId: "",
                vMenuName: undefined,
                iOrderNumber: "",
                iConfigStatus: "0",
                iMenuBelong: 2
              };
              this.getHourselistAjax();
              this.dialogVisible_specification = false;
            } else {
              return false;
            }
          });
        }
      }
    },
    // 弹窗是否关闭按钮
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
          if (this.activeName == "second") {
            this.dialogVisible = false;
            this.sizeForm = {
              vFatherId: "",
              vMenuName: undefined,
              iOrderNumber: "",
              iNullDisplay: "0",
              iConfigStatus: "0",
              iMenuBelong: 1
            };
          }
          if (this.activeName == "first") {
            this.dialogVisible_specification = false;
            this.sizeFormOther = {
              vFatherId: "",
              vMenuName: undefined,
              iOrderNumber: "",
              iConfigStatus: "0",
              iMenuBelong: 2
            };
          }
        })
        .catch(_ => {});
    },
    // 删除部门
    Delete(e) {
      this.open(e);
    },

    open(e) {
      this.$confirm(`是否确认删除名称为"${e.vMenuName}"的数据项？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { data: res } = await configListDelete(e.iConfigId);
          if (res.code !== 200)
            return this.$message({
              type: "error",
              message: res.msg
            });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getHourselistAjax();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 修改开关状态
    switch_value_btn(row) {
      let text = row.iConfigStatus === "0" ? "隐藏" : "显示";
      this.$confirm(
        '确认要"' + text + '""' + row.vMenuName + '"菜单吗?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          const { data: res } = await insertConfigchange(
            row.iConfigId,
            row.iConfigStatus
          );
          if (res.code !== 200) {
            row.iConfigStatus = row.iConfigStatus === "0" ? "1" : "0";
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.$message({
            type: "success",
            message: res.msg
          });
        })
        .catch(() => {
          row.iConfigStatus = row.iConfigStatus === "0" ? "1" : "0";
        });

      // .then(function() {
      //   return changeMenuStatus(row.menuId, row.status);
      // })
      // .then(() => {
      //   if (res.data.code !== 200)
      //     return this.$message({
      //       type: "success",
      //       message: res.data.msg
      //     });
      // })
      // .catch(function() {

      // });
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.iConfigId,
        label: node.vMenuName,
        children: node.children
      };
    },
    /** 查询菜单下拉树结构 */
    async getTreeselect() {
      if (this.activeName == "first") {
        const { data: res } = await configListAjax();
        this.menuOptions = [];
        const menu = { iConfigId: 0, vMenuName: "主类目", children: [] };
        menu.children = handleTreeOther(res.data.configList, "iConfigId");
        this.menuOptions.push(menu);
      }
      if (this.activeName == "second") {
        const { data: res } = await configListAjax();
        this.menuOptions = [];
        const menu = { iConfigId: 0, vMenuName: "主类目", children: [] };
        menu.children = handleTreeOther(res.data.houseConfigList, "iConfigId");
        this.menuOptions.push(menu);
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.dialogVisible_specification = false;
      this.sizeForm = {
        vFatherId: "",
        vMenuName: undefined,
        iOrderNumber: "",
        iNullDisplay: "0",
        iConfigStatus: "0",
        iMenuBelong: 1
      };
      this.sizeFormOther = {
        vFatherId: "",
        vMenuName: undefined,
        iOrderNumber: "",
        iConfigStatus: "0",
        iMenuBelong: 2
      };
    },
    // tabs切换
    TabsHandleClick(tab, event) {
      // console.log(tab, event);
    },
    // 上传图片按钮
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleAvatarSuccessFour(response) {
      this.sizeForm.vIcon = response.msg;
    }
  }
};
</script>

<style lang="less" scoped>
.department_title {
  // width: 72px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  color: #171a1e;
  margin-bottom: 20px;
}
.el-form-item--mini.el-form-item {
  margin-bottom: 24px;
  // height: 36px;
  /deep/.el-form-item__content {
    // height: 36px;
    .el-input--mini {
      // height: 36px;
      input {
        height: 36px;
      }
    }
  }
}
/deep/.demo-form-inline {
  .el-input__inner {
    width: 200px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background: #f6b439;
    border: 1px solid #f6b439;
  }
}
.newly_built {
  margin-top: 18px;
  margin-bottom: 20px;
  .newly_built_btn {
    width: 86px;
    height: 36px;
    text-align: center;
    padding: 0;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
}
.operation_right {
  margin-right: 20px;
}

/deep/.el-table th {
  text-align: center;
  background-color: #f2f2f2;
}
/deep/ .el-table__row td {
  text-align: center;
}

.dialog-footer {
  .add_new_btn {
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .cancel {
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
  }
}
/deep/.el-dialog__header {
  .el-dialog__title {
    font-weight: normal;
  }
}
/deep/.el-form-item--mini .el-form-item__label {
  font-weight: normal;
  color: #000;
  font-size: 16px;
}
/deep/.el-dialog {
  border-radius: 10px;
  padding: 10px 16px;
  .el-dialog__headerbtn {
    top: 36px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #000;
  }
}
/deep/.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 36px;
  font-size: 16px;
}
.menuType {
  width: 438px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 7px;
  height: 7px;
}
.el-dialog__footer {
  button {
    text-align: center;
    line-height: 13px;
    width: 72px;
    height: 36px;
  }
}
/deep/.el-tabs__item.is-active {
  color: #f6b439;
}
/deep/.el-tabs__active-bar {
  width: 98px;
  background-color: #f6b439;
}
/deep/.el-tabs__item:hover {
  color: #f6b439;
  cursor: pointer;
}
/deep/.el-tabs__item {
  font-size: 18px;
}
/deep/.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

/deep/.el-upload-list--picture-card .el-upload-list__item {
  height: 100px;
  width: 100px;
}
.el-icon-upload:before {
  font-size: 40px;
}
</style>
